import { connect } from 'react-redux';

import get from 'lodash/get';
import find from 'lodash/find';
import times from 'lodash/times';
import concat from 'lodash/concat';
import reject from 'lodash/reject';
import isEmpty from 'lodash/isEmpty';

import MapStylePresetsDisplay from './map_style_presets_display.jsx';

import {
  getThemes
} from 'zoomforth_codesbane_editor/reducers/index.js';

import {
  convertStylePresetsToOptionsList
} from 'zoomforth_codesbane_editor/lib/style_presets.js';

import {
  getStylePresets,
  getCurrentThemeUuid 
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  DUMMY_STYLE_PRESET
} from 'zoomforth_codesbane_editor/lib/style_presets.js';

const mapStateToProps = (state, { newThemeData })=> {
  const themes = getThemes(state);

  const oldThemeName = get(find(themes, ['uuid', getCurrentThemeUuid(state)]), 'name');
  var oldThemeStylePresets = reject(getStylePresets(state), ['className', '']);

  const newThemeName = get(find(themes, ['uuid', newThemeData.uuid]), 'name');
  var newThemeStylePresets = convertStylePresetsToOptionsList(newThemeData.stylePresets, {
    includeDefaultValue: false
  });

  // determine if we need to add "dummy" style presets into either list. these
  // will be filtered out of course but they allow us to map things to a "none"
  // preset which means we will NOT map those presets.
  const dummyStylePresets = times((
    oldThemeStylePresets.length > newThemeStylePresets.length ?
      oldThemeStylePresets.length - newThemeStylePresets.length
    : oldThemeStylePresets.length < newThemeStylePresets.length ?
      newThemeStylePresets.length - oldThemeStylePresets.length
    :
      0
    ),
    ()=> DUMMY_STYLE_PRESET
  );

  if (!isEmpty(dummyStylePresets) && oldThemeStylePresets.length > newThemeStylePresets.length) {
    newThemeStylePresets = concat(newThemeStylePresets, dummyStylePresets);

  } else if (!isEmpty(dummyStylePresets) && newThemeStylePresets.length > oldThemeStylePresets.length) {
    oldThemeStylePresets = concat(oldThemeStylePresets, dummyStylePresets);

  }

  return {
    oldThemeName,
    newThemeName,
    oldThemeStylePresets,
    newThemeStylePresets
  };
};

const mapDispatchToProps = ()=> {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MapStylePresetsDisplay);
